<template>
    <div class="body">
        <p  class="p1" style="padding-top: 8vh;">你是一位<a class="highlight" style="font-size: 24px;">{{ ReportData.lab  }}</a></p>

        <div v-show="ReportData.lab=='多场景学习型成长者'">
            <p class="p5">成长不是单一轨道</p>
            <p class="p6">学习，会在不同阶段留下痕迹</p>
            <p class="p7">我们很高兴，在这一刻与你相遇</p>
            <p class="p7">继续往下，你会看到一些值得探索的内容🌱</p>
        </div>
        <div v-show="ReportData.lab=='成长型学习者'">
            <p class="p5">你始终在学习中探索，在实践中累积</p>
            <p class="p6" style="margin-top: 20px;">你不断尝试新的学习内容，勇于挑战自我</p>
            <p class="p7">成长，正在你一次次投入中悄然发生</p>
        </div>
        <div v-show="ReportData.lab=='职业跃迁型成长者'">
            <p class="p5">你经历了角色与责任的双重升级</p>
            <p class="p6" style="margin-top: 20px;">系统化学习，构筑了你晋升背后的核心支撑</p>
            <p class="p6">这是一次具有里程碑意义的职业跃迁 🚀</p>
            <!-- <p class="p7">2025年学习学分达成：<a class="highlight">{{ ReportData.creditvalue }}</a>分</p> -->
            <!-- <div ref="PieChart" style="height: 30vh;"></div>
            <p class="p7" style="text-align: center;">💡 持续学习，让成长看得见</p> -->
        </div>
        <div v-show="ReportData.lab=='自主节奏型学习者'">
            <p class="p5">学习已成为你日常的一部分</p>
            <p class="p6" style="margin-top: 20px;">每一次积累都在悄然发生改变</p>
            <!-- <p class="p7">2025年学习学分达成：<a class="highlight">{{ ReportData.creditvalue }}</a>分</p> -->
            <!-- <div ref="PieChart" style="height: 30vh;"></div>
            <p class="p7" style="text-align: center;">💡 持续学习，让成长看得见</p> -->
        </div>
        <div v-show="ReportData.lab=='沉浸参与型学习者'">
            <p class="p5">你选择走进现场，🏫</p>
            <p class="p6" style="margin-top: 20px;">让学习在真实互动中发生。</p>
            <!-- <p class="p7">2025年学习学分达成：<a class="highlight">{{ ReportData.creditvalue }}</a>分</p> -->
            <!-- <div ref="PieChart" style="height: 30vh;"></div>
            <p class="p7" style="text-align: center;">💡 持续学习，让成长看得见</p> -->
        </div>
        <div v-show="ReportData.lab=='复合成长型学习者'">
            <p class="p5">你不拘于形式，🔄</p>
            <p class="p6" style="margin-top: 20px;">用适合自己的方式持续成长。</p>
            
            <!-- <div ref="PieChart" style="height: 30vh;"></div>
            <p class="p7" style="text-align: center;">💡 持续学习，让成长看得见</p> -->
        </div>
        <div v-show="ReportData.lab=='知识传承起航者'">
            <p class="p5">第一次站上讲台</p>
            <p class="p6" style="margin-top: 20px;">你正在积累属于自己的讲师力量。</p>
            <p class="p6">未来的影响力，正在发芽 🌱</p>
            <!-- <p class="p7">2025年学习学分达成：<a class="highlight" style="font-size: 24px;">{{ ReportData.creditvalue }}</a>分</p> -->
            <!-- <div ref="PieChart" style="height: 30vh;"></div>
            <p class="p7" style="text-align: center;">💡 持续学习，让成长看得见</p> -->
        </div>
        <div v-show="ReportData.lab=='学习转化型实践者'">
            <p class="p5">你把所学转化为分享🎯</p>
            <p class="p6">从一次次授课开始，走上讲台</p>
            <p class="p6">🌱 成长，正在发生</p>
        </div>
        <div v-show="ReportData.lab=='知识输出型赋能者'">
            <p class="p5">你持续站上讲台📘</p>
            <p class="p6" style="margin-top: 20px;">知识被不断打磨、传递与吸收</p>
            <p class="p6">你的经验，正在赋能更多人🤝</p>
        </div>
        <div v-show="ReportData.lab=='学习生态共建者'">
            <p class="p5">你高频参与教学现场🚀</p>
            <p class="p6" style="margin-top: 20px;">不只是授课，更在塑造学习方式</p>
            <p class="p6">你正在成为组织学习的重要力量</p>
        </div>
        <div v-show="ReportData.lab=='深度参与型学习者'">
            <p class="p5">你愿意持续投入🔁</p>
            <p class="p6" style="margin-top: 20px;">让学习慢慢沉淀</p>
            <p class="p6">你重视过程</p>
            <p class="p6">也在过程中积累真正的能力</p>
        </div>
        <p  v-show="ReportData.creditvalue" class="p7">2025年学习学分达成：<a class="highlight">{{ ReportData.creditvalue }}</a>分</p>
        <p  v-show="ReportData.creditvalueDiff && ReportData.creditvalueDiff>0" class="p6">比去年多了<a class="highlight">{{ ReportData.creditvalueDiff }}</a>分</p>
        <div v-show="ReportData.creditvalue" ref="PieChart" style="height: 30vh;"></div>
        <p class="p7" v-show="ReportData.creditvalue" style="text-align: center;">💡 持续学习，让成长看得见</p>
    </div>
</template>
  
<script>
import * as echarts from 'echarts';
export default {
    props: [ "ReportData"],
    data() {
        return {

        }
    },
    mounted(){
        this.initPieChart();
    },
    methods:{
        initPieChart() {
            const chartDom = this.$refs.PieChart;
            if (!chartDom) return;

            // 1️⃣ 数据为空，直接不画图
            if (!this.ReportData.creditvalueRate) {
                // console.warn('creditvalueRate 为空，饼图不渲染');
                return;
            }

            let rateObj = {};
            try {
                rateObj = JSON.parse(this.ReportData.creditvalueRate);
            } catch (e) {
                // console.error('creditvalueRate JSON 解析失败', e);
                return;
            }

            // 2️⃣ 转成 ECharts 数据
            const pieData = Object.keys(rateObj).map(key => ({
                name: key,
                value: rateObj[key]
            }));

            if (!pieData.length) return;

            const myChart = echarts.init(chartDom);

            myChart.setOption({
                color: ['#8ba3e1', 'pink', 'yellow'],
                series: [{
                    type: 'pie',
                    radius: '70%',
                    label: { 
                        show: true, 
                        fontSize: 13, 
                        color: '#fff',
                        textShadowColor: '#000', // 阴影颜色
                        textShadowBlur: 10,                     // 模糊程度
                        textShadowOffsetX: 2,                  // X 偏移
                        textShadowOffsetY: 1,  
                        formatter: function (params) {
                            // params.value === 当前值
                            if (!params.value || params.value === 0) {
                                return '';
                            }
                            return `${params.name}\n${params.value}%`;
                        }
                     },
                    // emphasis: {
                    //     label: {
                    //         show: true,
                    //         fontSize: 14,
                    //         formatter: '{b}\n{c}%',
                    //         color: '#fff'
                    //     }
                    // },
                    labelLine: {
                        show: true,
                        formatter: function (params) {
                            return params.value || params.value === 0 ? false : true;
                        }
                    },
                    data: pieData
                }]
            });
        }

    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/25October/logo.png") right  top  no-repeat,
                /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/25Year/bg.png")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  .highlight {
    font-size: 30px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }

  .p5, .p7{
    margin-top: 20px;
  }
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Year/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .p1,.p2, .p3, .p4 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 25px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .highlight {
    font-size: 40px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    margin:0 auto;
    text-align: center;
    font-size: 20px;
    width: 92%;
  }

  .p5, .p7{
    margin-top: 20px;
  }
}
</style>